import {Injectable} from '@angular/core';
import {ClientDetailsDTO} from '@dto/entities/client-details-dto.model';
import {Utils} from '@shared/utilities/utils';
import {ClientDetailsViewModel} from './client-details-view.model';

@Injectable({
  providedIn: 'root'
})
export class ClientDetailsConverterService {

  public convert(clientDetailsDTO: ClientDetailsDTO): ClientDetailsViewModel {
    return {
      code: clientDetailsDTO.code,
      name: clientDetailsDTO.name,
      type: clientDetailsDTO.type,
      iconURL: Utils.getClientIconSource(clientDetailsDTO.baseType),
      jurisdiction: clientDetailsDTO.jurisdiction
    };
  }
}
